import Vue from 'vue';
import router from '@/router';

import { HalfCircleSpinner } from 'epic-spinners';

import VueNumeric from 'vue-numeric';

import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import PortalVue from 'portal-vue';

import 'vue-search-select/dist/VueSearchSelect.css';

import vueDebounce from 'vue-debounce';


Vue.component('half-circle-spinner', HalfCircleSpinner);
Vue.use(VueNumeric);
Vue.component('multiselect', Multiselect);
Vue.use(PortalVue);
Vue.use(vueDebounce);

// Playback analytics uses the native batched collector; the retired Matomo host no longer serves a tracker.